import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { PrismCheckbox } from '@mylighthouse/prism-ember';
import { not } from 'ember-truth-helpers';

import styles from './item.module.css';

interface SettingsCurrencyConversionCurrencyPickerItemSignature {
  Args: {
    disabled?: boolean;
    dropdown: { toggleDropdown: () => void };
    onChange: (selected: boolean) => void;
    selected: boolean;
    subLabel?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLButtonElement;
}

const SettingsCurrencyConversionCurrencyPickerItem = <template>
  <button
    class="button--unstyled flex items-center gap-200 px-300
      {{if @disabled 'cursor-not-allowed'}}
      {{styles.item}}"
    disabled={{@disabled}}
    type="button"
    {{on "click" (fn @onChange (not @selected))}}
  >
    <PrismCheckbox
      @checked={{@selected}}
      @disabled={{@disabled}}
      @onChange={{fn @onChange (not @selected)}}
    />

    <div class="overflow-hidden py-200">
      <div class="text-300--regular text-neutral-emphasis">
        {{yield}}
      </div>
      {{#if @subLabel}}
        <p class="text-200--regular text-neutral-subdued">{{@subLabel}}</p>
      {{/if}}
    </div>
  </button>
</template> satisfies TOC<SettingsCurrencyConversionCurrencyPickerItemSignature>;

export default SettingsCurrencyConversionCurrencyPickerItem;
